import getYear from 'date-fns/get_year';

/**
 * Flyers that should never expire are published with a very far end date (to keep them visible):
 * that date must not be shown to the user. An end date is "far future" when its year is at least
 * {@link FAR_FUTURE_END_DATE_YEARS} after the current year.
 */
export const FAR_FUTURE_END_DATE_YEARS = 2;

export default (endDate, now = new Date()) => {
  if (!endDate) return false;
  const endYear = getYear(endDate);
  if (Number.isNaN(endYear)) return false;
  return endYear >= getYear(now) + FAR_FUTURE_END_DATE_YEARS;
};
